import creditCardDetails from 'Services/creditCardDetails'
import { ApiCreditCard, CreditCard } from 'Types'

const parseDigits = (digits: string): string => {
  const separator = '-'

  return digits.substring(digits.indexOf(separator) + 1)
}

export const parseCard = (data: ApiCreditCard): CreditCard => {
  const { icon, brand } = creditCardDetails(data.brand)
  const lastDigits = parseDigits(data.lastCreditCardNumber)

  return  {
    id: data.id,
    name: data.cardHolderName,
    digits: lastDigits,
    brand: brand,
    icon: icon,
    isMain: data.isMain,
  }
}

export default {
  parseCard
}